import VuexPersist from 'vuex-persist'

export const vuePresist = (store, key, modules = []) => new VuexPersist({
  key: key,
  storage: window.localStorage,
  saveState: (key, state, storage) => {
    localStorage.setItem(key, JSON.stringify(state));
  },
  restoreState: (key, storage) => {
    return JSON.parse(localStorage.getItem(key));
  },
  supportCircular: true,
  modules: modules
}).plugin(store);